// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles-module--wrap--scj3J","image":"styles-module--image--1lY2f"};